import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceGetStartedRoute: InvariantJiraRoute = {
	name: 'csm-experience-get-started',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/get-started',
	exact: true,
};
